export default __webpack_public_path__ + "svg/calendar/2027/1/abril.svg?61d8c130";